module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-Thin-046ff26493bd0c8b7af11d58d459e525.woff";